<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/view';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-spectrum/view/package.json';

```jsx import
import {Footer} from '@react-spectrum/view';
```

---
category: Content
---

# Footer

<p>{docs.exports.Footer.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Footer']} />

## Example

```tsx example
<Footer>&copy; All rights reserved.</Footer>
```

## Content

The `Footer` component represents a footer within a Spectrum container
such as a [Dialog](Dialog.html). `Footer` provides no specific styling by
itself, but receives styling from the parent container. In addition,
`Footer` will be automatically placed within the container's layout
according to Spectrum guidelines.

See [Dialog](Dialog.html#examples) for examples of how to use the
`Footer` component in the context of a Spectrum container.
See [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/footer)
for more information about the semantics of the `footer` element.

## Props

<PropTable component={docs.exports.Footer} links={docs.links} />
